<template>
    <div class="video-page">
        <div class="video-page__content">
            <h1 class="video-page__title">
                Your feedback makes a real difference.
            </h1>
            <p>
                We appreciate your time and expertise in helping us ensure the quality and integrity of the content.
            </p>
            <p>
                The video will be published online once it has been peer-reviewed by at least two medical professionals and approved by the Editorial Board.
            </p>
            <BaseButton
                :element="defineNuxtLink({})"
                to="/"
                class="video-page__videos-back"
                icon-left="arrow-left"
                tabindex="-1"
                aria-hidden="true"
            >
                Return to videos
            </BaseButton>
        </div>
    </div>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | Video Review Complete',
    description: 'Your feedback makes a real difference. We appreciate your time and expertise in helping us ensure the quality and integrity of the content.',
    ogImage: asset('/images/og/default.png')
});
</script>

<style lang="less" src="./VideoPage.less" />

<style lang="less" scoped>
.video-page__content {
    max-width: 100%;
    width: 37em;
    padding: 2em 1em;

    @media @q-lg-min {
        margin: 0 auto;
    }
}

.video-page__title {
    .typography-h1();
    max-width: var(--grid-maxWidth-contentMd);


    @media @q-md-min {
        .typography-h2-xs();
    }

    @media @q-lg-min {
        .typography-h2-md();
    }
}

.video-page__videos-back {
    margin-top: var(--spacing-lg);
}
</style>
